@if(!viewMode) {
  <div class="form-field-wrapper mb-4">
    <label class="form-field-label {{highlightClass ? highlightClass : ''}}" [ngClass]="{ 'required': isRequired }">
      <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
      {{ label }}
    </label>
    <div class="input-group form-input-group">
      <input
        class="form-field form-field__datepicker {{highlightClass ? highlightClass : ''}}"
        [placeholder]="placeholder | translate"
        [ngClass]="{ 'input-required': errorText }"
        [formControl]="formControl" name="dp"
        bsDatepicker
        [bsConfig]="bsConfig"
        #datepicker="bsDatepicker"
        autocomplete="off"
        [minDate]="minDate"
        [maxDate]="maxDate"
      >

      <button class="btn btn-outline-secondary calendar calendar-button" type="button" (click)="datepicker.toggle()">
        <i class="bi bi-calendar-check"></i>
      </button>

      @if (errorText) {
        <span class="form-field-info required-label">{{ errorText | translate }}</span>
      }
      @if (infoText && !errorText) {
        <span class="form-field-info">{{ infoText }}</span>
      }
    </div>
  </div>
} @else {
  <div class="form-field-wrapper">
    <div class="d-flex mb-2 responsive-field" [ngClass]="{ 'label-top-position': isLabelTopPosition }">
      <label class="form-field-label form-field-label__overview {{highlightClass ? highlightClass : ''}}"
        [ngClass]="{ 'required': isRequired, 'text-secondary': formControl.status === 'DISABLED' }">
        <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
        {{ label }}
      </label>

      @if(!inlineEditMode) {
        <div class="field-value field-value-inline {{highlightClass ? highlightClass : ''}}"
          (click)="formControl.status !== 'DISABLED' ? inlineEditMode = true : false"
          [ngClass]="{'text-secondary field-value-inline__disabled': formControl.status === 'DISABLED' }"
          attr.title="{{ formControl.status !== 'DISABLED' ? ('label.click_to_edit' | translate) : null }}">
          @if(formControl.value) {
            {{ formControl.value | date: 'yyyy-MM-dd' }}
          } @else {
            <span class="no-data-inline-form">/</span>
          }
        </div>
      } @else {
        <div class="input-group form-input-group">
          <input
            class="form-field form-field__datepicker form-field-inline form-field-inline__datepicker {{highlightClass ? highlightClass : ''}}"
            [placeholder]="placeholder | translate"
            [ngClass]="{ 'input-required': errorText }"
            [formControl]="formControl"
            name="dp"
            bsDatepicker
            [bsConfig]="bsConfig"
            #datepickerInline="bsDatepicker"
            autocomplete="off"
            [minDate]="minDate"
            [maxDate]="maxDate"
          >

          <button class="btn btn-outline-secondary calendar calendar-button calendar-button__inline" type="button" (click)="datepickerInline.toggle()">
            <i class="bi bi-calendar-check"></i>
          </button>

          @if (errorText) {
            <span class="form-field-info form-field-info-inline required-label">{{ errorText | translate }}</span>
          }
          @if (infoText && !errorText) {
            <span class="form-field-info form-field-info-inline">{{ infoText }}</span>
          }
        </div>
      }
    </div>
  </div>
}
